import { render, staticRenderFns } from "./indexLanding.vue?vue&type=template&id=730421c0"
import script from "./indexLanding.vue?vue&type=script&lang=js"
export * from "./indexLanding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports